<template>
    <div>
        <!-- <topSearch></topSearch> -->
        <!-- <breadcrumb></breadcrumb> -->

        <div class="top-title-content">
            <span class="title">회원관리</span>
            <span class="txt">
                센터에 등록한 회원님을 검색하실 수 있으며, 회원님의 성함을 눌러 이용권 등록 및 마일리지 등록 등 회원님의
                다양한 설정을 진행하실 수 있습니다.
            </span>
        </div>
        <loading-spinner v-if="isLoading"></loading-spinner>
        <template v-else>
            <div style="display: flex; gap: 28px">
                <div class="photo-info-card">
                    <img
                        class="photo"
                        :src="customerInfo.imageUrl === null ? '/img/icons/no_photo.jpg' : customerInfo.imageUrl"
                        alt="사진"
                    />
                    <div class="info-txt">
                        <span class="txt name">{{ customerInfo.name + ` (${customerInfo.attendNo})` }}</span>
                        <span class="txt">{{ customerInfo.phone | customerPhoneFilter }}</span>
                        <span class="txt">{{ convertTeamGroupsToString(customerInfo.centerCustomerTeamGroups) }}</span>
                        <span class="txt">-</span>
                    </div>
                    <span v-if="customerInfo.status === 'V'" class="icon green">유효</span>
                    <span v-if="customerInfo.status === 'E'" class="icon red">만료</span>
                    <span v-if="customerInfo.status === '-'" class="icon gray">잠재</span>
                    <span v-if="customerInfo.status === 'H'" class="icon yellow">홀딩</span>
                    <!--<button class="send-btn">인증코드전송</button>-->
                </div>
                <div class="d-flex flex-column" style="margin-top: 35px">
                    <button
                        v-if="hasMessageEvent && customerInfo.mktAgreeSms"
                        class="com-btn white"
                        @click="routing('messageSend', customerInfo)"
                    >
                        메시지 발송
                    </button>
                    <button
                        v-show="isAllowed('ME', 6)"
                        class="com-btn white"
                        style="margin-top: 10px"
                        @click="showContractSendPopup()"
                    >
                        계약서 발송
                    </button>
                </div>
                <div class="info-card">
                    <div class="info-txt">
                        <span class="txt name">최근 수업일</span>
                        <span class="txt">{{ lastLessonDaysAgo }}일전</span>
                        <span class="txt">마지막 출석: {{ customerInfo.latestLessonAt | dateFormatFilter }}</span>
                    </div>
                </div>
            </div>
            <div class="com-tab">
                <button @click="onClickRouter('/madmin/member/info')">기본정보</button>
                <button @click="onClickRouter('/madmin/member/payment')">결제내역</button>
                <button @click="onClickRouter('/madmin/member/cancel')">예약/취소내역</button>
                <button class="on">입장/출결내역</button>
                <button @click="onClickRouter('/madmin/member/mileage')">마일리지</button>
                <button
                    @click="
                        checkAllowedClick('MB', 3, () => {
                            onClickRouter('/madmin/member/advice');
                        })
                    "
                >
                    상담내역
                </button>
                <button @click="onClickRouter('/madmin/member/message')">메시지발송내역</button>
                <button v-show='isAllowed("ME", 7)' @click="onClickRouter('/madmin/member/contract_send')">계약서발송내역</button>
            </div>

            <div class="com-search-content">
                <div class="line">
                    <div class="com-calendar-wrap">
                        <single-calendar :start-date="startDate" @update="startDateUpdate"></single-calendar>
                        <div class="com-dash"><span class="dash">~</span></div>
                        <single-calendar :end-date="endDate" @update="endDateUpdate"></single-calendar>
                    </div>
                    <select-form
                        :select-data="['선택', ...periodTypeList]"
                        :select-value="['', ...periodTypeValueList]"
                        @update:set="(val) => (searchPeriod = val)"
                    ></select-form>
                </div>
                <div class="line">
                    <select-form
                        :select-data="['강사명', ...centerStaffList]"
                        :select-value="['', ...centerStaffValueList]"
                        class="w220"
                        @update:set="(val) => (centerStaffId = val)"
                    ></select-form>
                    <select-form
                        :select-data="['입장구분', ...atndStatusCodeList]"
                        :select-value="['', ...atndStatusCodeValueList]"
                        @update:set="(val) => (attendanceStatus = val)"
                    ></select-form>
                    <select-form
                        :select-data="['디바이스', ...atndDevCodeList]"
                        :select-value="['', ...atndDevCodeValueList]"
                        @update:set="(val) => (attendanceDevice = val)"
                    ></select-form>
                    <button class="com-search-reset" @click="resetSearchParams"></button>
                </div>
            </div>

            <div class="com-table-content">
                <table class="com-table">
                    <colgroup>
                        <col style="width: 180px" />
                        <col style="width: 615px" />
                        <col style="width: 180px" />
                        <col style="width: 140px" />
                        <col style="width: 140px" />
                        <col style="width: 140px" />
                    </colgroup>
                    <thead>
                        <tr>
                            <th>
                                <button @click="onClickCreDtColumn">시간</button>
                            </th>
                            <th>
                                <button @click="onClickLessNmColumn">이용권명</button>
                            </th>
                            <th>
                                <button @click="onClickLessDtColumn">수업일자</button>
                            </th>
                            <th>
                                <button @click="onClickStaffNmColumn">강사명</button>
                            </th>
                            <th>
                                <button @click="onClickAtndStatusColumn">입장구분</button>
                            </th>
                            <th>
                                <button @click="onClickAtndDeviceColumn">디바이스</button>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(e, index) in attendList" :key="index">
                            <td>{{ e.cth_entr_dt ? convertTime(e.cth_entr_dt) : '-' }}</td>
                            <td class="left">
                                <span
                                    :class="{
                                        ico: true,
                                        'type-1': e.cp_ticket_type_cd === 'P',
                                        'type-2': e.cp_ticket_type_cd === 'G',
                                        'type-4': e.cp_ticket_type_cd === 'T',
                                        'type-5': e.cp_ticket_type_cd === 'D',
                                        'type-6': e.cp_ticket_type_cd === 'O',
                                        'type-8': e.cp_ticket_type_cd === 'S',
                                    }"
                                >
                                    {{ convertTicketTypeFormat(e.cp_ticket_type_cd) }}
                                </span>
                                {{ e.ccp_prod_nm }}
                            </td>
                            <td>{{ convertTime2(e.cth_less_dt) }}</td>
                            <td>{{ e.cs_namee }}</td>
                            <td>{{ convertAtndStatusCode(e.cth_atnd_status_cd) }}</td>
                            <td>{{ convertAtndDevCode(e.cth_atnd_dev_cd) }}</td>
                        </tr>
                        <tr v-if="attendList.length === 0">
                            <td colspan="100">등록된 내용이 없습니다.</td>
                        </tr>
                    </tbody>
                </table>
                <div class="sort-bottom-area">
                    <select-form
                        :select-data="[...sortTypeList]"
                        :select-value="[...sortTypeValueList]"
                        class="float-right"
                        @update:set="onChangeLimit"
                    ></select-form>
                </div>
                <b-pagination
                    v-model="pagingInfo.page"
                    :per-page="pagingInfo.limit"
                    :total-rows="pagingInfo.totalItems"
                    align="center"
                    aria-controls="my-table"
                    first-class="first"
                    last-class="last"
                    next-class="next"
                    prev-class="prev"
                    @change="handlerPagenation"
                ></b-pagination>
            </div>
        </template>
        <contract-send-dlg
            v-if="contractSendPop"
            :show="contractSendPop"
            :info="contractSendInfo"
            :close="handleCloseContractSend"
            :charge="handleCharge"
            :paymentLinkSend="handlePaymentLinkSend"
        ></contract-send-dlg>
    </div>
</template>

<script>
import api from '@/assets/js/api';
import { MixinAllowedMenu } from '@/assets/js/mixinAllowedMenu';
import moment from 'moment';
import EventBus from '../../../assets/js/eventBus';
import { pagingInfo } from '@/assets/js/common';
import ContractSendDlg from '../../../components/ContractSendDlg';

export default {
    name: 'memberAttend',
    mixins: [MixinAllowedMenu],
    components: {
        ContractSendDlg,
    },
    props: {},
    computed: {
        lastLessonDaysAgo() {
            if (this.customerInfo.latestLessonAt) {
                return moment().startOf('day').diff(moment(this.customerInfo.latestLessonAt).startOf('day'), 'days');
            }

            return '-';
        }
    },
    watch: {
        searchPeriod(newValue) {
            // 검색 기간 설정 변수
            this.searchPeriod = newValue;

            if (newValue === 'today') {
                // 오늘
                this.startDate = moment().format('YYYY-MM-DD');
                this.endDate = moment().format('YYYY-MM-DD');
            } else if (newValue === 'yesterday') {
                // 어제
                this.startDate = moment().subtract(1, 'days').format('YYYY-MM-DD');
                this.endDate = moment().subtract(1, 'days').format('YYYY-MM-DD');
            } else if (newValue === 'thisMonth') {
                // 이번 달
                this.startDate = moment().startOf('month').format('YYYY-MM-DD');
                this.endDate = moment().endOf('month').format('YYYY-MM-DD');
            } else if (newValue === 'prevMonth') {
                // 지난 달
                this.startDate = moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD');
                this.endDate = moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD');
            } else if (newValue === '3M') {
                // 3개월
                this.startDate = moment().subtract(3, 'months').format('YYYY-MM-DD');
                this.endDate = moment().format('YYYY-MM-DD');
            } else if (newValue === '6M') {
                // 6개월
                this.startDate = moment().subtract(6, 'months').format('YYYY-MM-DD');
                this.endDate = moment().format('YYYY-MM-DD');
            } else if (newValue === '12M') {
                // 12개월
                this.startDate = moment().subtract(12, 'months').format('YYYY-MM-DD');
                this.endDate = moment().format('YYYY-MM-DD');
            } else if (newValue === '') {
                this.initStartDate();
                this.initEndDate();
            }
        },
        startDate(newValue) {
            // 검색 시작일
            this.startDate = newValue;
        },
        endDate(newValue) {
            // 검색 종료일
            this.endDate = newValue;
        },
        centerStaffId(newValue) {
            // 강사명
            this.centerStaffId = newValue;
            this.fetchAttendList();
        },
        attendanceStatus(newValue) {
            // 입장 상태 (출석미승인 : -, 출석승인 : O, 입장 : I, 결석 : X)
            this.attendanceStatus = newValue;
            this.fetchAttendList();
        },
        attendanceDevice(newValue) {
            // 디바이스 (AW : 관리자웹, AA : 관리자앱, CA : 회원앱, TU : 터치모니터)
            this.attendanceDevice = newValue;
            this.fetchAttendList();
        },
    },
    mounted() {
        this.init();
    },
    data() {
        return {
            hasMessageEvent: false, // 메시지 계약되었을시..

            isLoading: false,
            centerId: this.$route.params.id,
            customerId: this.$route.query.customerId,
            customerInfo: {}, // 회원 정보

            pagingInfo: { ...pagingInfo },
            attendList: [],

            periodTypeList: [...this.$periodTypeList],
            periodTypeValueList: [...this.$periodTypeValueList],

            centerStaffList: [],
            centerStaffValueList: [],
            atndStatusCodeList: ['출석미승인', '출석승인', '입장', '결석'], // 입장 상태 코드 이름 (출석미승인 : -, 출석승인 : O, 입장 : I, 결석 : X)
            atndStatusCodeValueList: ['-', 'O', 'I', 'X'], // 입장 상태 코드 값
            atndDevCodeList: ['관리자웹', '관리자앱', '회원앱', '터치모니터'], // 출결 장비 코드 (AW : 관리자웹, AA : 관리자앱, CA : 회원앱, TU : 터치모니터)
            atndDevCodeValueList: ['AW', 'AA', 'CA', 'TU'], // 출결 장비 코드 값

            startDate: '', // 검색 파라미터 (시작일)
            endDate: '', // 검색 파라미터 (종료일)

            centerStaffId: '', // 검색 파라미터 (강사명)
            attendanceStatus: '', // 검색 파라미터 (입장상태)
            attendanceDevice: '', // 검색 파라미터 (디바이스)
            searchPeriod: '', // 검색 기간 설정

            sortTypeList: [...this.$sortType],
            sortTypeValueList: [...this.$sortTypeValue],

            attendSortType: 'DESC', // 정렬방법 (오름차순 : ASC, 내림차순 : DESC)
            attendSortColumn: '', // 정렬컬럼 (createDate, lessonName, lessonDate, centerStaffname, attendanceStatus, attendanceDevice)

            contractSendPop: false,
            contractSendInfo: {},
            centerInfo: {},
        };
    },
    methods: {
        routing(toName, checkedUserData) {
            const routingData = [];
            console.log(checkedUserData);
            // checkedUserData.forEach((param) => {
            const tempValue = {
                ...checkedUserData,
            };
            routingData.push(tempValue);
            // });
            this.$router.push({
                name: toName,
                params: { data: routingData },
            });
        },

        checkMessageEvent() {
            return api
                .get('/admin/api/center/ftcontract/sms')
                .then((res) => {
                    this.hasMessageEvent = JSON.parse(res.data);
                })
                .catch((error) => {
                    this.hasMessageEvent = false;
                });
        },

        // 초기화
        async init() {
            this.isLoading = true;
            this.pagingInfo.page = 1;
            this.pagingInfo.limit = 10;
            this.initStartDate(); // 검색 시작일 초기화
            this.initEndDate(); // 검색 종료일 초기화
            await this.fetchCenterStaffList(); // 직원 목록 가져오기
            await this.fetchCustomerDetail(); // 회원 정보 가져오기
            await this.fetchAttendList(); // 입장/출석 목록 가져오기
            await this.checkMessageEvent();
            this.getCenterInfo(); // 로그인한 센터 정보 가져오기
            this.isLoading = false;
        },
        // centerId 로 센터 정보 가져오기
        async getCenterInfo() {
            try {
                const { data } = await this.sendGetCenter();
                this.centerInfo = data;
            } catch (error) {
                console.log(error);
            }
        },

        // 센터 조회 API 호출
        sendGetCenter() {
            return api.get(`/admin/api/center/${this.centerId}`);
        },

        // 회원 정보 가져오기
        async fetchCustomerDetail() {
            try {
                const { data } = await this.sendGetCustomerDetail();
                this.customerInfo = data;
                this.customerInfo.centerCustomerTeamGroups = this.customerInfo.centerCustomerTeamGroups.filter(
                    (g) => !g.centerCustomerTeam.info.deleteYn
                );
            } catch (error) {
                alert('회원정보를 가져오는 중 오류가 발생했습니다.');
                console.log(error);
            }
        },

        // 회원 기본정보 조회 API 호출
        sendGetCustomerDetail() {
            return api.get(`/admin/api/center/${this.centerId}/customer/${this.customerId}`);
        },

        // 페이지 이동
        onClickRouter(path) {
            this.$router.push({ path: `${path}/${this.centerId}`, query: { customerId: this.customerId } });
        },

        // 회원 정보 카드에 나타낼 회원 그룹 이름 만들기
        convertTeamGroupsToString(teamGroups) {
            if (teamGroups === undefined) {
                return;
            }
            if (teamGroups.length === 1) {
                // 그룹이 1개일 경우
                return teamGroups[0].centerCustomerTeamName;
            } else if (teamGroups.length === 0) {
                // 그룹이 없을 경우
                return '-';
            } else if (teamGroups.length > 1) {
                // 그룹이 여러개일 경우
                return `${teamGroups[0].centerCustomerTeamName} 외 ${teamGroups.length - 1}`;
            }
        },

        // 입장/출석 목록 가져오기
        async fetchAttendList() {
            try {
                const { data } = await this.sendGetAttendList();
                this.setPageParams(data);
                this.attendList = data.items;
            } catch (error) {
                alert('입장/출석 목록을 가져오는 중 오류가 발생했습니다.');
                console.log(error);
            }
        },

        // 입장/출석 목록 API 호출
        sendGetAttendList() {
            const { startDate, endDate, centerStaffId, attendanceStatus, attendanceDevice, customerId } = this;
            let searchParams = {
                startDate,
                endDate,
                centerStaffId,
                attendanceStatus,
                attendanceDevice,
                centerCustomerId: customerId,
            };
            if (attendanceStatus == '') searchParams.justAttendData = true;

            const sortParams = {
                sortType: this.attendSortType, // 정렬방법 (오름차순 : ASC, 내림차순 : DESC)
                sortColumn: this.attendSortColumn, // 정렬컬럼 (createDate, lessonName, lessonDate, centerStaffname, attendanceStatus, attendanceDevice)
            };
            return api.get(`/admin/api/center/${this.centerId}/lesson/schedule/customer/attendance/all`, {
                params: {
                    ...this.pagingInfo,
                    ...searchParams,
                    ...sortParams,
                },
            });
        },

        // 직원(상담자) 목록 가져오기
        async fetchCenterStaffList() {
            try {
                const { data } = await this.sendGetCenterStaffList();
                data.forEach((d) => {
                    this.centerStaffList.push(d.name);
                    this.centerStaffValueList.push(d.centerStaffId);
                });
            } catch (error) {
                alert('직원 목록을 가져오는 중 오류가 발생했습니다.');
                console.log(error);
            }
        },

        // 직원 목록 API 호출
        sendGetCenterStaffList() {
            return api.get(`/admin/api/center/${this.centerId}/staff/teachers/list`);
        },

        // 검색 시작일 초기화
        initStartDate() {
            const startDate = moment().subtract(1, 'months').format('YYYY-MM-DD');
            this.startDate = startDate;
        },

        // 검색 종료일 초기화
        initEndDate() {
            const endDate = moment().format('YYYY-MM-DD');
            this.endDate = endDate;
        },

        // 검색 시작일 변경 event
        startDateUpdate(val) {
            this.startDate = val;
            this.fetchAttendList();
        },

        // 검색 종료일 변경 event
        endDateUpdate(val) {
            this.endDate = val;
            this.fetchAttendList();
        },

        // 검색 조건 초기화
        resetSearchParams() {
            this.initStartDate(); // 시작일 검색 파라미터
            this.initEndDate(); // 종료일 검색 파라미터
            this.searchPeriod = '';
            this.centerStaffId = '';
            this.attendanceStatus = '';
            this.attendanceDevice = '';
            this.fetchAttendList();
            EventBus.$emit('event:initList', 'init');
        },

        // 예약 상태 String 변환
        convertAtndDevCode(atndDevCode) {
            if (atndDevCode === 'AW') {
                return '관리자웹';
            } else if (atndDevCode === 'AA') {
                return '관리자앱';
            } else if (atndDevCode === 'CA') {
                return '회원앱';
            } else if (atndDevCode === 'TU') {
                return '터치모니터';
            }
        },

        // 입장구분 String 변환
        convertAtndStatusCode(atndStatusCode) {
            if (atndStatusCode === '-') {
                return '출석미승인';
            } else if (atndStatusCode === 'O') {
                return '출석승인';
            } else if (atndStatusCode === 'I') {
                return '입장';
            } else if (atndStatusCode === 'X') {
                return '결석';
            }
        },

        // 페이징 이벤트
        handlerPagenation(event) {
            this.pagingInfo.page = event;
            this.fetchAttendList();
        },

        // 페이징 Param set
        setPageParams(data) {
            this.pagingInfo.totalPages = data.meta.totalPages;
            this.pagingInfo.page = data.meta.currentPage;
            this.pagingInfo.totalItems = data.meta.totalItems;
            this.pagingInfo.itemCount = data.meta.itemCount;
        },

        // 한 페이지에 표시되는 줄 수 변경
        onChangeLimit(val) {
            this.pagingInfo.limit = val;
            this.fetchAttendList();
        },

        // 이용권 코드 변환
        convertTicketTypeFormat(type) {
            if (type === 'P') {
                return '[개인]';
            } else if (type === 'O') {
                return '[OT]';
            } else if (type === 'D') {
                return '[듀엣]';
            } else if (type === 'G') {
                return '[그룹]';
            } else if (type === 'C') {
                return '[쿠폰]';
            } else if (type === 'T') {
                return '[회원권]';
            } else if (type === 'S') {
                return '[운동복]';
            }
        },

        // 시간 컬럼 클릭시
        onClickCreDtColumn() {
            this.attendSortColumn = 'createDate';
            if (this.attendSortType === '' || this.attendSortType === 'DESC') {
                this.attendSortType = 'ASC';
            } else {
                this.attendSortType = 'DESC';
            }
            this.fetchAttendList();
        },

        // 이용권명 컬럼 클릭시
        onClickLessNmColumn() {
            this.attendSortColumn = 'lessonName';
            if (this.attendSortType === '' || this.attendSortType === 'DESC') {
                this.attendSortType = 'ASC';
            } else {
                this.attendSortType = 'DESC';
            }
            this.fetchAttendList();
        },

        // 수업일자 컬럼 클릭시
        onClickLessDtColumn() {
            this.attendSortColumn = 'lessonDate';
            if (this.attendSortType === '' || this.attendSortType === 'DESC') {
                this.attendSortType = 'ASC';
            } else {
                this.attendSortType = 'DESC';
            }
            this.fetchAttendList();
        },

        // 강사명 컬럼 클릭시
        onClickStaffNmColumn() {
            this.attendSortColumn = 'centerStaffName';
            if (this.attendSortType === '' || this.attendSortType === 'DESC') {
                this.attendSortType = 'ASC';
            } else {
                this.attendSortType = 'DESC';
            }
            this.fetchAttendList();
        },

        // 입장구분 컬럼 클릭시
        onClickAtndStatusColumn() {
            this.attendSortColumn = 'attendanceStatus';
            if (this.attendSortType === '' || this.attendSortType === 'DESC') {
                this.attendSortType = 'ASC';
            } else {
                this.attendSortType = 'DESC';
            }
            this.fetchAttendList();
        },

        // 디바이스 컬럼 클릭시
        onClickAtndDeviceColumn() {
            this.attendSortColumn = 'attendanceDevice';
            if (this.attendSortType === '' || this.attendSortType === 'DESC') {
                this.attendSortType = 'ASC';
            } else {
                this.attendSortType = 'DESC';
            }
            this.fetchAttendList();
        },
        convertTime(time) {
            return time ? moment(time).locale('ko').format('YYYY.MM.DD HH:mm:SS') : '-';
        },
        convertTime2(time) {
            return time ? moment(time).subtract('hours', 9).locale('ko').format('YYYY.MM.DD HH:mm:SS') : '-';
        },

        handleCloseContractSend() {
            this.contractSendPop = false;
        },

        handleCharge() {
            this.contractSendPop = false;
        },

        handlePaymentLinkSend() {
            this.contractSendPop = false;

            this.onClickRouter('/madmin/member/contract_send');
        },

        showContractSendPopup() {
            this.contractSendInfo = {
                centerId: this.centerId,
                centerName: this.centerInfo.centerName,
                customerId: this.customerId,
                customerName: this.customerInfo.name,
                customerPhone: this.customerInfo.phone,
                templateType: 'M',
            };
            this.contractSendPop = true;
        },
    },
};
</script>
<style lang="scss"></style>
